import React from "react";

const initialFormData = {
    processBbnDetailId: {value: null},
    processBbnId: {value: ""},
    receiverType: {value: ""},
    receiverName: {value: "", mandatory: true},
    nik: {value: ""},
    noWa: {value: "", mandatory: true},
    noHp: {value: "", mandatory: true},
    address: {value: "", mandatory: true},
    documentCode: {value: ""},
    province: {value: "", mandatory: true},
    kabKot: {value: "", mandatory: true},
    kecamatan: {value: "", mandatory: true},
    kelurahan: {value: "", mandatory: true},
    zipCode: {value: "", mandatory: true},
    receiverPhoto: {value: "", mandatory: true},
    idPhoto: {value: "", mandatory: true},
    suratKuasa: {value: ""},
    sidikJari: {value: ""},
    staffId: {value: ""},
    date: {value: ""},
    time: {value: ""},
}

export const formGroupBBNIndividu = {
    STNK: {...initialFormData},
    PAJAK: {...initialFormData},
    PLAT: {...initialFormData},
    BPKB: {
        ...initialFormData,
        suratKuasa: {value: "", mandatory: true},
        sidikJari: {value: "", mandatory: true}
    },
}

export const initialData = {
    search: {
        startPeriod: null,
        endPeriod: null,
        stnkName: null,
    },
    filter: {
        startPeriod: null,
        endPeriod: null,
        facture: null,
        bookNumber: null,
        kodeVariant: null,
        kodeWarna: null,
        stnkName: null,
        buyerName: null,
        frameNumber: null,
        engineNumber: null,
        stnkStatus: null,
        pajakStatus: null,
        platStatus: null,
        bpkbStatus: null,
    }
}

export const tableColumns = {
    mainPage: [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                    return <>{rowNumber}</>;
                },
                sort: false,
            },
        },
        {
            name: "factureDate",
            label: "Tanggal Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "facture",
            label: "Nomor Faktur Jual",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "bookNumber",
            label: "No. Buku",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "variant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
                sort: false,
            },
        },
        {
            name: "variant",
            label: "Nama Varian",
            options: {
                customBodyRender: (val) => <p>{val?.namaVariant}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Kode Warna",
            options: {
                customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
                sort: false,
            },
        },
        {
            name: "warna",
            label: "Nama Warna",
            options: {
                customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
                sort: false,
            },
        },
        {
            name: "stnkName",
            label: "Nama STNK",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "buyer",
            label: "Nama Pembeli",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "frameNumber",
            label: "Nomor Rangka",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "engineNumber",
            label: "Nomor Mesin",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "stnkStatus",
            label: "STNK",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div className="margin-bottom-none width width-100px">
                            <input
                                id="input_text_kodeKSU"
                                style={{backgroundColor: getColor(val)}}
                                type="text"
                                className="txt txt-sekunder-color"
                                disabled={true}
                                value={val ?? ""}
                            />
                        </div>
                    )
                },
                sort: false,
            },
        },
        {
            name: "pajakStatus",
            label: "Lembar Pajak",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div className="margin-bottom-none width width-100px">
                            <input
                                id="input_text_kodeKSU"
                                style={{backgroundColor: getColor(val)}}
                                type="text"
                                className="txt txt-sekunder-color"
                                disabled={true}
                                value={val ?? ""}
                            />
                        </div>
                    )
                },
                sort: false,
            },
        },
        {
            name: "platStatus",
            label: "Plat Kendaraan",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div className="margin-bottom-none width width-100px">
                            <input
                                id="input_text_kodeKSU"
                                style={{backgroundColor: getColor(val)}}
                                type="text"
                                className="txt txt-sekunder-color"
                                disabled={true}
                                value={val ?? ""}
                            />
                        </div>
                    )
                },
                sort: false,
            },
        },
        {
            name: "bpkbStatus",
            label: "BPKB",
            options: {
                customBodyRender: (val) => {
                    return (
                        <div className="margin-bottom-none width width-100px">
                            <input
                                id="input_text_kodeKSU"
                                style={{backgroundColor: getColor(val)}}
                                type="text"
                                className="txt txt-sekunder-color"
                                disabled={true}
                                value={val ?? ""}
                            />
                        </div>
                    )
                },
                sort: false,
            },
        },

    ]
}

const getColor = (val) => {
    switch (val) {
        case "Ready":
            return "lime";
        case "Received":
            return "yellow";
        case "Not Ready":
            return "red";
        default:
            return "#E6E6E6";
    }
}